import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Box,
  Button,
  IconButton,
  Typography,
  TextField,
  Select,
  MenuItem,
  ListItemIcon,
  Grid,
  CircularProgress,
  Backdrop,
} from "@mui/material";
import { useState } from "react";
import {
  createSection,
  updateSection,
} from "../../../services/onboardingService/onboardingService";
import { Editor } from "@tinymce/tinymce-react";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { useLocation, useNavigate } from "react-router-dom";
import { colors } from "../../../utils/constant";
import previewCourseDefaultImage from "../../../asset/images/preview-course-default.jpeg";
import AlertSnackbar from "../../../components/AlertSnackbar";
import { FormControlLabel, Switch } from "@mui/material";
import ReactPlayer from "react-player";
import {SketchPicker} from "react-color";
const CreateEditSection = () => {
  const location = useLocation();
  const [isLoading, setIsLoading]= useState(false);
  const [snackbar, setSnackbar] = useState({ open: false, message: "", severity: "success" }); 
  const data = location.state || {};
  const navigate = useNavigate();
  const [formData, setFormData] = useState({
    title: data.title || "Title",
    videoUrl: data.videoUrl || "",
    content: data.content || "",
    closeTitleBackgroundColor: data.closeTitleBackgroundColor || "#4CA154",
    closeTitleTextColor: data.closeTitleTextColor || "#FFFFFF",
    closeTitleOutlineColor: data.closeTitleOutlineColor || "#4CA154",
    openTitleBackgroundColor: data.openTitleBackgroundColor || "#E9F4EA",
    openTitleTextColor: data.openTitleTextColor || "#000000",
    openTitleOutlineColor: data.openTitleOutlineColor || "#E9F4EA",
    openLessonOutlineColor: data.openLessonOutlineColor || "#E9F4EA",
  });
  const [isEditing, setIsEditing] = useState(true);
  const [expanded, setExpanded] = useState(true);
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value,
    });
  };

  const handleColorChange = (color, name) => {
    setFormData({
      ...formData,
      [name]: color.hex,
    });
  };

  const [colorPickerState, setColorPickerState] = useState({});

  const renderColorSelect = (label, name, value) => (
    <Grid item xs={3} sx={{ paddingInline: "5px", position: "relative" }}>
      <Typography
        variant="subtitle1"
        sx={{ mt: 2, fontSize: "14px", fontWeight: "500" }}
      >
        {label}
      </Typography>
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          cursor: "pointer",
          border: "1px solid #E0E0E0",
          borderRadius: "4px",
          padding: "5px",
        }}
        onClick={() => {
          setColorPickerState((prev) => {
            const newState = Object.keys(prev).reduce((acc, key) => {
              acc[key] = false;
              return acc;
            }, {});
            return { ...newState, [name]: !prev[name] };
          })}}
      >
        <Box
          sx={{
            width: "30px",
            height: "30px",
            borderRadius: "4px",
            backgroundColor: value,
            marginRight: "10px",
          }}
        ></Box>
        <Typography variant="body2">{value}</Typography>
      </Box>
      {colorPickerState[name] && (
        <Box sx={{ position: "absolute", zIndex: 1 }}>
          <SketchPicker
            presetColors={colors}
            width={250}
            color={value}
            onChangeComplete={(color) => {
              setFormData((prev) => ({
                ...prev,
                [name]: color.hex,
              }));
              setColorPickerState((prev) => ({ ...prev, [name]: false }));
            }}
          />
        </Box>
      )}
    </Grid>
  );

  const onSubmit = async (e) => {
    try{
      setIsLoading(true);
      e.preventDefault();
      console.log("Submitted Data:", formData);
      if (data?.sectionId) {
        await updateSection({ ...formData, sectionId: data.sectionId });
      } else {
        await createSection(formData);
      }
      setSnackbar({
        open: true,
        message: "Section saved Successfully",
        severity: "success",
      });
    }
    catch(err){
      setSnackbar({
        open: true,
        message: err.response.data.message || "Something Went Wrong",
        severity: "error",
      })
    }
    setIsLoading(false);
  };
  const handleCloseSnackbar = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setSnackbar((prev) => ({ ...prev, open: false }));
  };
  return (
    <div style={{ height: "200vh" }}>
      <Box display="flex" alignItems="center" mb={2}>
        <IconButton
          onClick={() => navigate("/onboarding")}
          aria-label="go back"
          title="Go Back"
          sx={{ marginBottom: "0.35em", marginRight: "0.1em" }}
        >
          <ArrowBackIcon />
        </IconButton>
        <Typography variant="h1" gutterBottom>
          {data?.sectionId ? "Edit Section" : "Create New Section"}
        </Typography>
        
        <FormControlLabel
          control={
            <Switch
              checked={!isEditing}
              onChange={() => setIsEditing(!isEditing)}
              name="previewToggle"
              color="primary"
            />
          }
          label={"Preview"}
          sx={{ marginLeft: "auto" }}
        />
      </Box>

      <Accordion expanded={expanded}
      onChange={() => setExpanded(!expanded)}
      sx={{
        "&::before": { display: "none" },
        boxShadow:"none",
        borderRadius:"10px",
        "& .MuiAccordionSummary-root": {
          borderRadius: expanded?"10px 10px 0px 0px":"10px",
          backgroundColor: expanded ? formData.openTitleBackgroundColor : formData.closeTitleBackgroundColor,
          borderTop: expanded ? `3px solid ${formData.openTitleOutlineColor}` : `3px solid ${formData.closeTitleOutlineColor}`,
          borderLeft: expanded ? `3px solid ${formData.openTitleOutlineColor}` : `3px solid ${formData.closeTitleOutlineColor}`,
          borderRight: expanded ? `3px solid ${formData.openTitleOutlineColor}` : `3px solid ${formData.closeTitleOutlineColor}`,
          borderBottom: expanded ? `0px` : `3px solid ${formData.closeTitleOutlineColor}`,
          color: expanded ? formData.openTitleTextColor : formData.closeTitleTextColor,
        },
        "&  .MuiAccordionDetails-root": {
          borderRadius:'0px 0px 10px 10px',
          border: expanded ? `3px solid ${formData.openLessonOutlineColor}` : "none",
        },
        "& .MuiAccordionSummary-content": {
          margin: "12px 0px" ,
        },
        width: "100%",
      }}>
        <AccordionSummary
          expandIcon={<ExpandMoreIcon />}
          aria-controls="panel1a-content"
          id="panel1a-header"
        >
          {isEditing ? (
            <Box sx={{ width: "100%", display: "flex", justifyContent: "center" }}>
              <TextField
                name="title"
                value={formData.title}
                onChange={handleChange}
                onClick={(e) => e.stopPropagation()}
                onFocus={(e) => e.stopPropagation()}
                sx={{
                  width: "80%",
                  input: {
                    color: expanded ? formData.openTitleTextColor : formData.closeTitleTextColor,
                    textAlign: "center",
                    fontSize: "1.5rem",
                    fontWeight: "600",
                    margin: "0px",
                    padding: "0px",
                    marginBottom: "3px"
                  },
                  "& .MuiOutlinedInput-root": {
                    "& fieldset": {
                    border: "none",
                    },
                    "&:hover fieldset": {
                    border: "none",
                    },
                    "&.Mui-focused fieldset": {
                    border: "none",
                    },
                  },
                }}
              />
            </Box>
          ) : (
            <Typography variant="h5"  sx={{fontSize:"1.5rem",fontWeight:"600", textAlign:"center", width:"100%"}}>{formData.title}</Typography>
          )}
        </AccordionSummary>
        <AccordionDetails>
          {isEditing ? 
          <Box sx={{marginTop:"1rem"}} display="flex" flexDirection="column" width="100%" gap={2}>
            <TextField
              label="Video URL"
              name="videoUrl"
              value={formData.videoUrl}
              onChange={handleChange}
            />
            <Editor
              tinymceScriptSrc="/tinymce/tinymce.min.js"
              value={formData.content}
              id="fancy-text-tool-area"
              name="description"
              init={{
                height: 200,
                entity_encoding: "raw",
                license_key: "gpl",
                plugins: [
                  "autolink",
                  "lists",
                  "link",
                  "charmap",
                  "preview",
                  "searchreplace",
                  "fullscreen",
                  "media",
                  "table",
                  "code",
                  "emoticons",
                ],
                toolbar:
                  "undo redo | " +
                  "formatselect | " +
                  "bold italic underline strikethrough | " +
                  "alignleft aligncenter alignright | " +
                  "bullist numlist | " +
                  "link emoticons | " +
                  "code removeformat",
                emoticons_append: {
                  custom_mind_explode: {
                    keywords: ["brain", "mind", "explode", "blown"],
                    char: "🤯",
                  },
                },
                branding: false,
                statusbar: false,
                menubar: false,
                content_style: "p { margin: 0}",
              }}
              onEditorChange={(content) =>
                setFormData({ ...formData, content })
              }
            />
            <Grid container display="flex" mt={2}>
              {renderColorSelect("Close Title Background Color", "closeTitleBackgroundColor", formData.closeTitleBackgroundColor)}
              {renderColorSelect("Close Title Text Color", "closeTitleTextColor", formData.closeTitleTextColor)}
              {renderColorSelect("Close Title Outline Color", "closeTitleOutlineColor", formData.closeTitleOutlineColor)}

              {renderColorSelect("Open Title Background Color", "openTitleBackgroundColor", formData.openTitleBackgroundColor)}
              {renderColorSelect("Open Title Text Color", "openTitleTextColor", formData.openTitleTextColor)}
              {renderColorSelect("Open Title Outline Color", "openTitleOutlineColor", formData.openTitleOutlineColor)}

              {renderColorSelect("Open Lesson Outline Color", "openLessonOutlineColor", formData.openLessonOutlineColor)}
            </Grid>
            <Button onClick={onSubmit} variant="contained" sx={{ marginTop: 2 }}>Save</Button>
          </Box>
          :
            <Box sx={{display:"flex", flexDirection:"column", width:"50%", margin:"auto", justifyContent: "center", alignItems:"center" ,gap:2, paddingTop:"22px"}} >
                <ReactPlayer
                  url={formData.videoUrl}
                  width="600px"
                  height="300px"
                  controls
                  muted={false}
                  playing={false}
                  volume={0}
                />
              <Box sx={{width:"600px", margin:"auto"}}>
                <Typography sx={{ "& ul":{listStyle:"disc",marginLeft:"18px"}, "& ol":{listStyle:"decimal",marginLeft:"18px"} , "& a":{color:"#4CA154",textDecoration:"underline"}}}>
                  <div dangerouslySetInnerHTML={{ __html: formData.content }} />
                </Typography>
              </Box>
            </Box>
          }
        </AccordionDetails>
      </Accordion>
      {isLoading && <Backdrop
          sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
          open={isLoading}
        >
          <CircularProgress
           color="inherit" />
        </Backdrop>}
        <AlertSnackbar
        open={snackbar.open}
        handleClose={handleCloseSnackbar}
        message={snackbar.message}
        severity={snackbar.severity}
      />
    </div>
  );
};

export default CreateEditSection;
